import { useState } from 'react';

import { EditableTitle } from '@utilities';

import styles from './_index.module.scss';

interface HierarchyPromptInputProps {
  ariaInvalid: boolean;
  onChange: (value: string) => void;
  options: string[];
  placeholder: string;
  promptKey: string;
  value: string;
}

const HierarchyPromptInput = ({
  ariaInvalid,
  onChange,
  options,
  placeholder,
  promptKey,
  value,
}: HierarchyPromptInputProps) => {
  const [isFocused, setIsFocused] = useState(false);
  const handleChange = (nextValue: string) => {
    if (nextValue.includes('[')) setIsFocused(true);

    onChange(nextValue);
  };
  const searchTerm = value.match(/\[([^\]]*)$/)?.[1].toLowerCase();
  const matchingOptions =
    isFocused && searchTerm !== undefined
      ? options.filter((option) => option.toLowerCase().includes(searchTerm))
      : [];

  return (
    <div
      className={styles['hierarchy-prompt-input-autocomplete']}
      onBlurCapture={() => setIsFocused(false)}
      onFocusCapture={() => setIsFocused(true)}
    >
      <EditableTitle
        aria-invalid={ariaInvalid}
        className={styles['hierarchy-prompt-input-prompt']}
        onBlur={onChange}
        onChange={handleChange}
        placeholder={placeholder}
        value={value}
      />
      {matchingOptions.length > 0 && (
        <div
          className={styles['hierarchy-prompt-input-suggestions']}
          data-testid={`screener-hierarchy-suggestions-${promptKey.replace(/_/g, '-')}`}
          role="listbox"
        >
          {matchingOptions.map((option) => (
            <button
              key={option}
              onClick={() => {
                onChange(`[${option}]`);
                setIsFocused(false);
              }}
              onMouseDown={(event) => event.preventDefault()}
              role="option"
              type="button"
            >
              {option}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default HierarchyPromptInput;
